<footer class="app-footer">
  <span>
    © {{ currentYear }} Whopperads-Lead Management System | All rights reserved | Designed &
    Developed by
    <a
      href="https://www.crystalcodelabs.com/"
      target="_blank"
      rel="noopener noreferrer"
      class="fw-bold"
    >
      Crystal Code Labs
    </a>
  </span>
</footer>
